import React from "react";
import {
  Container,
  Grid,
  Typography,
  Link,
  Box,
  Divider,
  IconButton,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";

const Footer = () => {
  const productLinks = [
    { label: "Features", href: "#features" },
    { label: "Pricing", href: "#" },
    { label: "Dashboard", href: "#dashboard" },
    { label: "Security", href: "#security" },
    { label: "API Documentation", href: "#" },
  ];

  const companyLinks = [
    { label: "About Us", href: "#" },
    { label: "Contact", href: "#contact" },
    { label: "Privacy Policy", href: "#" },
    { label: "Terms of Service", href: "#" },
    { label: "Support", href: "#" },
  ];

  const socialLinks = [
    { icon: <LinkedInIcon />, href: "#", label: "LinkedIn" },
    { icon: <TwitterIcon />, href: "#", label: "Twitter" },
    { icon: <FacebookIcon />, href: "#", label: "Facebook" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#1A1A2E",
        color: "white",
        pt: 8,
        pb: 4,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Column 1 - Brand */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 3 }}>
              {/* Logo */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "10px",
                    background:
                      "linear-gradient(135deg, #9B5DE5 0%, #6F2DBD 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1.5,
                  }}
                >
                  <Box
                    component="img"
                    src="/logo/logo-single-white.svg"
                    alt="aroundU Monitor Logo"
                    sx={{
                      width: 40,
                      height: 40,
                      color: "white",
                    }}
                  />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.25rem",
                  }}
                >
                  aroundU Monitor
                </Typography>
              </Box>

              {/* Tagline */}
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255, 255, 255, 0.7)",
                  mb: 3,
                  lineHeight: 1.7,
                  maxWidth: 300,
                }}
              >
                Modern workforce monitoring for modern teams. Streamline
                operations and boost productivity with real-time insights.
              </Typography>

              {/* Social Icons */}
              <Box sx={{ display: "flex", gap: 1 }}>
                {socialLinks.map((social, index) => (
                  <IconButton
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    sx={{
                      color: "rgba(255, 255, 255, 0.7)",
                      "&:hover": {
                        color: "white",
                        backgroundColor: "rgba(155, 93, 229, 0.2)",
                      },
                    }}
                  >
                    {social.icon}
                  </IconButton>
                ))}
              </Box>
            </Box>
          </Grid>

          {/* Column 2 - Product */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                fontSize: "1.125rem",
              }}
            >
              Product
            </Typography>
            <Box
              component="nav"
              sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
            >
              {productLinks.map((link, index) => (
                <Link
                  key={index}
                  href={link.href}
                  underline="none"
                  sx={{
                    color: "rgba(255, 255, 255, 0.7)",
                    fontSize: "0.875rem",
                    transition: "color 0.3s ease",
                    "&:hover": {
                      color: "white",
                    },
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Column 3 - Company */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600,
                fontSize: "1.125rem",
              }}
            >
              Company
            </Typography>
            <Box
              component="nav"
              sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
            >
              {companyLinks.map((link, index) => (
                <Link
                  key={index}
                  href={link.href}
                  underline="none"
                  sx={{
                    color: "rgba(255, 255, 255, 0.7)",
                    fontSize: "0.875rem",
                    transition: "color 0.3s ease",
                    "&:hover": {
                      color: "white",
                    },
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Row */}
        <Divider
          sx={{
            mt: 6,
            mb: 3,
            borderColor: "rgba(255, 255, 255, 0.1)",
          }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          {/* Copyright */}
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255, 255, 255, 0.6)",
              fontSize: "0.875rem",
            }}
          >
            © 2026 aroundU Monitor. All rights reserved.
          </Typography>

          {/* Additional Links */}
          <Box sx={{ display: "flex", gap: 3 }}>
            <Link
              href="#"
              underline="none"
              sx={{
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.875rem",
                "&:hover": {
                  color: "white",
                },
              }}
            >
              Cookies
            </Link>
            <Link
              href="#"
              underline="none"
              sx={{
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.875rem",
                "&:hover": {
                  color: "white",
                },
              }}
            >
              Sitemap
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
